import { render, staticRenderFns } from "./MailTemplateEditorCard.vue?vue&type=template&id=4a97f76c&scoped=true"
import script from "./MailTemplateEditorCard.vue?vue&type=script&lang=js"
export * from "./MailTemplateEditorCard.vue?vue&type=script&lang=js"
import style0 from "./MailTemplateEditorCard.vue?vue&type=style&index=0&id=4a97f76c&prod&scoped=true&lang=css"
import style1 from "./MailTemplateEditorCard.vue?vue&type=style&index=1&id=4a97f76c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a97f76c",
  null
  
)

export default component.exports